import React from "react";
import { Image, Text, View } from "react-native";
import { ConnectorCategory } from "@axio/graphql/generated/graphql";
import INTEGRATIONS_ICONS, { type IntegrationIconKey } from "../../../../assets/integrations";

const CATEGORY_COLORS: Record<ConnectorCategory, { bg: string; text: string }> = {
  [ConnectorCategory.CloudStorage]: { bg: "#EFF6FF", text: "#2563EB" },
  [ConnectorCategory.VideoService]: { bg: "#F5F3FF", text: "#7C3AED" },
  [ConnectorCategory.LmsRepository]: { bg: "#F0FDFA", text: "#0D9488" },
  [ConnectorCategory.AdminKnowledgeBase]: { bg: "#F0F9FF", text: "#0369A1" },
  [ConnectorCategory.LibraryRepository]: { bg: "#FFF7ED", text: "#EA580C" },
  [ConnectorCategory.WebCms]: { bg: "#ECFDF3", text: "#027A48" },
};

export function ConnectorLogo({
  iconKey,
  category,
  size = 40,
}: {
  iconKey?: string;
  category: ConnectorCategory;
  size?: number;
}) {
  const iconValue = iconKey ? INTEGRATIONS_ICONS[iconKey as IntegrationIconKey] : undefined;
  const colors = CATEGORY_COLORS[category];
  const containerStyle = {
    width: size,
    height: size,
    borderRadius: 10,
    overflow: "hidden" as const,
    alignItems: "center" as const,
    justifyContent: "center" as const,
    flexShrink: 0,
  };

  if (!iconValue) {
    const initials = (iconKey || category)
      .split("-")
      .map((segment) => segment.charAt(0))
      .join("")
      .slice(0, 2)
      .toUpperCase();

    return (
      <View style={[containerStyle, { backgroundColor: colors.bg }]}>
        <Text style={{ fontSize: size * 0.32, fontWeight: "700", color: colors.text }}>{initials}</Text>
      </View>
    );
  }

  return (
    <View style={[containerStyle, { backgroundColor: colors.bg ?? "#F3F4F6" }]}>
      <Image
        source={{ uri: iconValue }}
        style={{
          width: size * 0.7,
          height: size * 0.7,
        }}
        testID="connector-logo-svg"
      />
    </View>
  );
}
